export default {
    getAboutMe(state){
        return state.aboutMe;
    },
    getEducations(state) {
        return state.educations;
    },
    getExperiences(state) {
        return state.experiences;
    }
}